import { IChildProp } from "@intelligence/components/Form/type";
import { convertDataSourceAndSource } from "@intelligence/_config/enumeration/dataSource";

const PC_METRICS_TABLE_DATA_SOURCE = {
  steamcharts: ['pcu','acu', 'steamFollowers', 'steamReviews'],
  mscience: ['digitalRevenue', 'units', 'digitalARPPU', 'ast'],
  gsd: ['digitalUnitsGSD', 'physicalUnitsGSD', 'digitalRevenueGSD', 'physicalRevenueGSD'],
  npd: ['physicalRevenue', 'physicalUnits'],
  vginsightsPC: ['steamRevenue_pcMetrics', 'steamUnits_pcMetrics', 'steamPrice_pcMetrics'], 
  databrain: ['mau', 'playerShare', 'mauGrowth', 'mauNew', 'mauReturning', 'lifetimePlayer', 'timeSpent0h','timeSpent1h', 'timeSpent5h', 'timeSpent10h', 'timeSpent25h', 'timeSpent50h', 'avgDailyPlaytime', 'avgDailySessions', 'avgPlaytimePerSession', 'avgMonthlyPlaytime', 'avgMonthlySessions', 'avgDaysPlayed', 'stickness', 'totalHours', 'churn', 'acquisition', 'retentionD1', 'retentionD2', 'retentionD4', 'retentionD7', 'retentionD14', 'retentionD28'],
};

const getMetricsChildren = () => convertDataSourceAndSource(PC_METRICS_TABLE_DATA_SOURCE, {
  disableCondition: {
    gsd: 'additionalFields:dateType:daily||additionalFields:dateType:monthly',
    npd: 'additionalFields:dateType:daily||additionalFields:dateType:weekly',
    databrain: 'additionalFields:dateType:daily||additionalFields:dateType:weekly',
  },
  disableMsgKey: {
    gsd: 'dbi_info_gsd_metrics_category_disabled_tips',
    npd: 'dbi_info_physical_monthly_only',
    databrain: 'dbi_info_newzoo_bymonth',
  },
  // 默认权限，convertDataSourceAndSource会过滤禁选的选项
  isDefault: {
    steamcharts: 'all',
    mscience: ['digitalRevenue', 'digitalARPPU', 'ast'],
    gsd: 'all',
    npd: 'all',
    databrain: 'all',
    vginsightsPC: 'all',
  },
});

const PC_METRICS_TABLE_DOWNLOAD_SET: IChildProp[] =
  [{
    enumKey: 'mutilMetrics',
    enumTargetType: 'downloadMainCategory',
    type: 'cascader',
    children: getMetricsChildren(),
  },
  {
    enumKey: 'basicInformation',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      enumKey: 'hasCompany',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasGenre',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasRelease',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasRegion',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasSteamId',
      enumTargetType: 'downloadBasicInfo',
    }],
  },
  {
    enumKey: 'dataCalculation',
    enumTargetType: 'downloadMainCategory',
    type: 'subForm',
    className: 'form-item--top-18',
    children: [{
      enumKey: 'timeSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isTimeAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeparateByTime',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'regionSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isCountryAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeperateByCountries',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeperateByRegion',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'ratio',
      enumTargetType: 'downloadMainCategory',
      type: 'switch',
      condition: '!additionalFields:businessType:mobile-rpd',
      isDefault: true,
    }, {
      label: 'PCU Settings',
      labelKey: 'dbi_pcu_setting',
      value: 'pcuSettings',
      type: 'text',
      children: [{
        label: 'All',
        labelKey: 'dbi_all',
        value: 'all'
      }]
    }, {
      label: 'Digital Revenue Settings',
      labelKey: 'dbi_digital_revenue_setting',
      value: 'digitalRevenueSettings',
      type: 'text',
      children: [{
        label: 'All',
        labelKey: 'dbi_all',
        value: 'all'
      }]
    }, {
      label: 'Physical Revenue Settings',
      labelKey: 'dbi_physical_revenue_setting',
      value: 'physicalRevenueSettings',
      type: 'text',
      children: [{
        label: 'All',
        labelKey: 'dbi_all',
        value: 'all'
      }]
    }, {
      label: 'Steam Premium Revenue Settings',
      labelKey: 'dbi_premium_revenue_setting',
      value: 'steamPremiumRevenueSettings',
      type: 'text',
      children: [{
        label: 'All',
        labelKey: 'dbi_all',
        value: 'all'
      }]
    }, {
      label: 'Steam Price Settings',
      labelKey: 'dbi_price_setting',
      value: 'steamPriceSettings',
      type: 'text',
      children: [{
        label: 'All',
        labelKey: 'dbi_all',
        value: 'all'
      }]
    }],
  }, {
    enumKey: 'dataAmount',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportAllData',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'selectTop',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'exportSelected',
      enumTargetType: 'downloadOther',
    }]
  }, {
    enumKey: 'selectTop',
    enumTargetType: 'downloadMainCategory',
    type: 'inputNumber',
    // 默认值，带?为变量传入，不带为正常值
    defaultValue: '?additionalFields:initialSelectTop',
    condition: 'dataAmount:top',
  }, {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportExcel',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'exportCSV',
      enumTargetType: 'downloadOther',
    }],
  }];

const PC_UNIVERSAL_DOWNLOAD_SET: IChildProp[] =
  [{
    enumKey: 'singleMetrics',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      isDefault: true,
      // enumKey指向dataSource中DATA_SOURCE_METRICS的key
      enumKey: 'pcu',
      condition: 'additionalFields:businessType:pc-PCU',
    }, {
      isDefault: true,
      enumKey: 'avgPlayers',
      condition: 'additionalFields:businessType:pc-PCU',
    }, {
      isDefault: true,
      enumKey: 'steamFollowers',
      condition: 'additionalFields:businessType:pc-PCU',
    }, {
      isDefault: true,
      enumKey: 'steamReviews',
      condition: 'additionalFields:businessType:pc-PCU',
    }, {
      isDefault: true,
      enumKey: 'physicalRevenue',
      condition: 'additionalFields:businessType:pc-PhysicalRevenue',
    }, {
      isDefault: true,
      enumKey: 'physicalUnits',
      condition: 'additionalFields:businessType:pc-PhysicalRevenue',
    }, {
      isDefault: true,
      enumKey: 'estRevenue_pcMetrics',
      condition: 'additionalFields:businessType:pc-SteamSales',
    }, {
      isDefault: true,
      enumKey: 'estUnit_pcMetrics',
      condition: 'additionalFields:businessType:pc-SteamSales',
    }, {
      isDefault: true,
      enumKey: 'price',
      condition: 'additionalFields:businessType:pc-SteamSales',
    }, {
      isDefault: true,
      enumKey: 'weightedPrice',
      condition: 'additionalFields:businessType:pc-SteamSales',
    }, {
      isDefault: true,
      enumKey: 'totalFollowers',
      condition: 'additionalFields:businessType:pc-SteamSales',
    }, {
      isDefault: true,
      enumKey: 'playersByCountry',
      condition: 'additionalFields:businessType:pc-SteamSales',
    }, {
      isDefault: true,
      enumKey: 'avgPlaytime',
      condition: 'additionalFields:businessType:pc-SteamSales',
    }, {
      isDefault: true,
      enumKey: 'mau',
      condition: 'additionalFields:businessType:pc-MAU',
    }, {
      isDefault: true,
      enumKey: 'acquisition',
      condition: 'additionalFields:businessType:pc-MAU',
    }],
  },
  {
    enumKey: 'basicInformation',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      enumKey: 'hasCompany',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasGenre',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasRelease',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasRegion',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasSteamId',
      enumTargetType: 'downloadBasicInfo',
    }],
  },
  {
    enumKey: 'dataCalculation',
    enumTargetType: 'downloadMainCategory',
    type: 'subForm',
    className: 'form-item--top-18',
    children: [{
      enumKey: 'timeSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isTimeAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeparateByTime',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'regionSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'text',
      condition: 'additionalFields:businessType:pc-PCU||additionalFields:businessType:pc-PhysicalRevenue||additionalFields:businessType:pc-MAU',
      children: [{
        enumKey: 'isCountryAggregated',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'ratio',
      enumTargetType: 'downloadMainCategory',
      type: 'switch',
      isDefault: true,
    }, {
      label: 'PCU Settings',
      labelKey: 'dbi_pcu_setting',
      value: 'pcuSettings',
      type: 'text',
      condition: 'additionalFields:businessType:pc-PCU',
      children: [{
        label: 'All',
        labelKey: 'dbi_all',
        value: 'all'
      }]
    }, {
      label: 'Physical Revenue Settings',
      labelKey: 'dbi_physical_revenue_setting',
      value: 'physicalRevenueSettings',
      type: 'text',
      condition: 'additionalFields:businessType:pc-PhysicalRevenue',
      children: [{
        label: 'All',
        labelKey: 'dbi_all',
        value: 'all'
      }]
    }, {
      label: 'Steam Premium Revenue Settings',
      labelKey: 'dbi_premium_revenue_setting',
      value: 'steamPremiumRevenueSettings',
      condition: 'additionalFields:businessType:pc-SteamSales',
      type: 'text',
      children: [{
        label: 'All',
        labelKey: 'dbi_all',
        value: 'all'
      }]
    }, {
      label: 'Steam Price Settings',
      labelKey: 'dbi_price_setting',
      value: 'steamPriceSettings',
      condition: 'additionalFields:businessType:pc-SteamSales',
      type: 'text',
      children: [{
        label: 'All',
        labelKey: 'dbi_all',
        value: 'all'
      }]
    }],
  }, {
    enumKey: 'dataAmount',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportAllData',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'selectTop',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'exportSelected',
      enumTargetType: 'downloadOther',
    }]
  }, {
    enumKey: 'selectTop',
    enumTargetType: 'downloadMainCategory',
    type: 'inputNumber',
    // 默认值，带?为变量传入，不带为正常值
    defaultValue: '?additionalFields:initialSelectTop',
    condition: 'dataAmount:top',
  }, {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportExcel',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'exportCSV',
      enumTargetType: 'downloadOther',
    }],
  }];

const PC_DIGITAL_REVENUE_DOWNLOAD_SET: IChildProp[] =
  [{
    enumKey: 'singleMetrics',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      isDefault: true,
      enumKey: 'digitalRevenue',
    }, {
      isDefault: true,
      enumKey: 'units',
    }, {
      isDefault: true,
      enumKey: 'digitalARPPUSimple',
      msgKey: 'dbi_metric_digital_arpu_dollor_tips',
    }, {
      isDefault: true,
      enumKey: 'ast',
    }],
  },
  {
    enumKey: 'basicInformation',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      enumKey: 'hasCompany',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasGenre',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasRelease',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasRegion',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasSteamId',
      enumTargetType: 'downloadBasicInfo',
    }],
  },
  {
    enumKey: 'dataCalculation',
    enumTargetType: 'downloadMainCategory',
    type: 'subForm',
    className: 'form-item--top-18',
    children: [{
      label: 'Segment Settings',
      labelKey: 'dbi_label_segment_settings',
      value: 'special_segmentSettings',
      type: 'checkboxGroup',
      children: [{
        isDefault: true,
        enumKey: 'fullGame',
        enumTargetType: 'segment',
      }, {
        isDefault: true,
        enumKey: 'dlcAllOther',
        enumTargetType: 'segment',
      }, {
        isDefault: true,
        enumKey: 'dlcExpansion',
        enumTargetType: 'segment',
      }, {
        isDefault: true,
        enumKey: 'dlcSeasonPass',
        enumTargetType: 'segment',
      }, {
        isDefault: true,
        enumKey: 'dlcBattlePass',
        enumTargetType: 'segment',
      }, {
        isDefault: true,
        enumKey: 'mtx',
        enumTargetType: 'segment',
      }, {
        isDefault: true,
        enumKey: 'subscription',
        enumTargetType: 'segment',
      }],
    }, {
      enumKey: 'timeSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isTimeAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeparateByTime',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'regionSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isCountryAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeperateByCountries',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeperateByRegion',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'ratio',
      enumTargetType: 'downloadMainCategory',
      type: 'switch',
      isDefault: true,
    }, {
      label: 'Digital Revenue Settings',
      labelKey: 'dbi_digital_revenue_setting',
      value: 'digitalRevenueSettings',
      type: 'text',
      children: [{
        label: 'All',
        labelKey: 'dbi_all',
        value: 'all'
      }]
    }],
  }, {
    enumKey: 'dataAmount',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportAllData',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'selectTop',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'exportSelected',
      enumTargetType: 'downloadOther',
    }]
  }, {
    enumKey: 'selectTop',
    enumTargetType: 'downloadMainCategory',
    type: 'inputNumber',
    // 默认值，带?为变量传入，不带为正常值
    defaultValue: '?additionalFields:initialSelectTop',
    condition: 'dataAmount:top',
  }, {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportExcel',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'exportCSV',
      enumTargetType: 'downloadOther',
    }],
  }];

const PC_OHTERS_DOWNLOAD_SET: IChildProp[] =
  [{
    enumKey: 'singleMetrics',
    enumTargetType: 'downloadMainCategory',
    type: 'text',
    condition: '!additionalFields:businessType:pc-newRelease&&!additionalFields:businessType:pc-upcoming',
    children: [{
      isDefault: true,
      enumKey: 'lifetimePlayer',
    }],
  },
  {
    enumKey: 'basicInformation',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      enumKey: 'hasCompany',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasGenre',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasRelease',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasRegion',
      enumTargetType: 'downloadBasicInfo',
    }, {
      enumKey: 'hasSteamId',
      enumTargetType: 'downloadBasicInfo',
    }],
  },
  {
    enumKey: 'dataCalculation',
    enumTargetType: 'downloadMainCategory',
    type: 'subForm',
    condition: '!additionalFields:businessType:pc-newRelease&&!additionalFields:businessType:pc-upcoming',
    className: 'form-item--top-18',
    children: [{
      enumKey: 'timeSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'radio',
      children: [{
        isDefault: true,
        enumKey: 'isTimeAggregated',
        enumTargetType: 'downloadDataCalcu',
      }, {
        enumKey: 'isSeparateByTime',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'regionSettings',
      enumTargetType: 'downloadMainCategory',
      type: 'text',
      children: [{
        enumKey: 'isCountryAggregated',
        enumTargetType: 'downloadDataCalcu',
      }]
    }, {
      enumKey: 'ratio',
      enumTargetType: 'downloadMainCategory',
      type: 'switch',
      isDefault: true,
    }],
  }, {
    enumKey: 'dataAmount',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportAllData',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'selectTop',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'exportSelected',
      enumTargetType: 'downloadOther',
    }]
  }, {
    enumKey: 'selectTop',
    enumTargetType: 'downloadMainCategory',
    type: 'inputNumber',
    // 默认值，带?为变量传入，不带为正常值
    defaultValue: '?additionalFields:initialSelectTop',
    condition: 'dataAmount:top',
  }, {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [{
      isDefault: true,
      enumKey: 'exportExcel',
      enumTargetType: 'downloadOther',
    }, {
      enumKey: 'exportCSV',
      enumTargetType: 'downloadOther',
    }],
  }];

export default {
  pcMetricsTable: PC_METRICS_TABLE_DOWNLOAD_SET,
  pcUniversal: PC_UNIVERSAL_DOWNLOAD_SET,
  pcDigitalRevenue: PC_DIGITAL_REVENUE_DOWNLOAD_SET,
  pcOthers: PC_OHTERS_DOWNLOAD_SET,
};
